import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=88e4d3e0&scoped=true"
import script from "./payroll.vue?vue&type=script&lang=js"
export * from "./payroll.vue?vue&type=script&lang=js"
import style0 from "./payroll.vue?vue&type=style&index=0&id=88e4d3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e4d3e0",
  null
  
)

export default component.exports